import { Directive, HostListener, Input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
    selector: '[appTooltip]',
    standalone: true
})
export class TooltipDirective {
    @Input() set appTooltip(showOnClick: boolean) {
        this.showOnClick = showOnClick;
    }

    showOnClick = false;

    constructor(private elem: MatTooltip) {
    }

    @HostListener('click')
    onClick() {
        this.elem.toggle();
    }

    @HostListener('mouseover', ['$event'])
    onHoverIn() {
        this.elem.show();
    }

    @HostListener('mouseout', ['$event'])
    onHoverOut() {
        this.elem.hide();
    }
}
